const ImgLoad = {
	props: {
		url: String,
		render: Function
	},
	data: () => ({
		ready: false
	}),
	created () {
		const ghost = document.createElement('img')
		ghost.onload = () => {
			this.ready = true
		}
		ghost.src = this.url
	},
	render () {
		return this.render({
			ready: this.ready
		})
	}
}

export default ImgLoad



// WEBPACK FOOTER //
// ./src/components/ImgLoad/index.js